<p>google-maps-style works!</p>
